// @needsAudit
/**
 * The type of notification feedback generated by a `UINotificationFeedbackGenerator` object.
 * [`UINotificationFeedbackType`](https://developer.apple.com/documentation/uikit/uinotificationfeedbackgenerator/feedbacktype).
 */ export var NotificationFeedbackType = /*#__PURE__*/ function(NotificationFeedbackType) {
    /**
   * A notification feedback type indicating that a task has completed successfully.
   */ NotificationFeedbackType["Success"] = "success";
    /**
   * A notification feedback type indicating that a task has produced a warning.
   */ NotificationFeedbackType["Warning"] = "warning";
    /**
   * A notification feedback type indicating that a task has failed.
   */ NotificationFeedbackType["Error"] = "error";
    return NotificationFeedbackType;
}({});
// @needsAudit
/**
 * The mass of the objects in the collision simulated by a `UIImpactFeedbackGenerator` object
 * [`UINotificationFeedbackStyle`](https://developer.apple.com/documentation/uikit/uiimpactfeedbackgenerator/feedbackstyle).
 */ export var ImpactFeedbackStyle = /*#__PURE__*/ function(ImpactFeedbackStyle) {
    /**
   * A collision between small, light user interface elements.
   */ ImpactFeedbackStyle["Light"] = "light";
    /**
   * A collision between moderately sized user interface elements.
   */ ImpactFeedbackStyle["Medium"] = "medium";
    /**
   * A collision between large, heavy user interface elements.
   */ ImpactFeedbackStyle["Heavy"] = "heavy";
    /**
   * A collision between user interface elements that are soft, exhibiting a large amount of compression or elasticity.
   */ ImpactFeedbackStyle["Soft"] = "soft";
    /**
   * A collision between user interface elements that are rigid, exhibiting a small amount of compression or elasticity.
   */ ImpactFeedbackStyle["Rigid"] = "rigid";
    return ImpactFeedbackStyle;
}({});
/**
 * @platform android
 */ export var AndroidHaptics = /*#__PURE__*/ function(AndroidHaptics) {
    /**
   * A haptic effect to signal the confirmation or successful completion of a user interaction.
   */ AndroidHaptics["Confirm"] = "confirm";
    /**
   * A haptic effect to signal the rejection or failure of a user interaction.
   */ AndroidHaptics["Reject"] = "reject";
    /**
   * The user has started a gesture (for example, on the soft keyboard).
   */ AndroidHaptics["Gesture_Start"] = "gesture-start";
    /**
   * The user has finished a gesture (for example, on the soft keyboard).
   */ AndroidHaptics["Gesture_End"] = "gesture-end";
    /**
   * The user has toggled a switch or button into the on position.
   */ AndroidHaptics["Toggle_On"] = "toggle-on";
    /**
   * The user has toggled a switch or button into the off position.
   */ AndroidHaptics["Toggle_Off"] = "toggle-off";
    /**
   * The user has pressed either an hour or minute tick of a Clock.
   */ AndroidHaptics["Clock_Tick"] = "clock-tick";
    /**
   * The user has performed a context click on an object.
   */ AndroidHaptics["Context_Click"] = "context-click";
    /**
   * The user has started a drag-and-drop gesture. The drag target has just been "picked up".
   */ AndroidHaptics["Drag_Start"] = "drag-start";
    /**
   * The user has pressed a soft keyboard key.
   */ AndroidHaptics["Keyboard_Tap"] = "keyboard-tap";
    /**
   * The user has pressed a virtual or software keyboard key.
   */ AndroidHaptics["Keyboard_Press"] = "keyboard-press";
    /**
   * The user has released a virtual keyboard key.
   */ AndroidHaptics["Keyboard_Release"] = "keyboard-release";
    /**
   * The user has performed a long press on an object that results in an action being performed.
   */ AndroidHaptics["Long_Press"] = "long-press";
    /**
   * The user has pressed on a virtual on-screen key.
   */ AndroidHaptics["Virtual_Key"] = "virtual-key";
    /**
   * The user has released a virtual key.
   */ AndroidHaptics["Virtual_Key_Release"] = "virtual-key-release";
    /**
   * No haptic feedback should be performed.
   */ AndroidHaptics["No_Haptics"] = "no-haptics";
    /**
   * The user is switching between a series of potential choices. For example, items in a list or discrete points on a slider.
   */ AndroidHaptics["Segment_Tick"] = "segment-tick";
    /**
   * The user is switching between a series of many potential choices. For example, minutes on a clock face or individual percentages.
   * This constant is expected to be very soft, so as not to be uncomfortable when performed a lot in quick succession.
   * If the device can't make a suitably soft vibration, then it may not make any vibration.
   */ AndroidHaptics["Segment_Frequent_Tick"] = "segment-frequent-tick";
    /**
   * The user has performed a selection/insertion handle move on text field.
   */ AndroidHaptics["Text_Handle_Move"] = "text-handle-move";
    return AndroidHaptics;
}({});

//# sourceMappingURL=Haptics.types.js.map
